// import RepositoryFactory from "@/apis";
// const hoc = RepositoryFactory.hoc;
import hoc from "../../apis/hoc";

export default {
  createSharework({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await hoc.createSharework(payload);
        // console.log(data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getSharework({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await hoc.getSharework(payload);
        commit("SET_SHAREWORK", data.data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  updateSharework({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await hoc.updateSharework(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteSharework({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await hoc.deleteSharework(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  setLike({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log(payload);
        const { data } = await hoc.setLike(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  emailContactUs({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await hoc.emailContactUs(payload);
        // console.log(data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
